import {
    showMoreReviews,
    clickFAQ,
    clickBackToTop,
    trackClickIBubbleOverall,
    trackClickIBubbleWaitTime,
    trackClickIBubbleBedsideManner,
    trackProfileScrollCount,
} from './actions';

export default {
    handleClickShowMoreReviews: showMoreReviews,
    clickFAQ,
    clickBackToTop,
    trackClickIBubbleOverall,
    trackClickIBubbleWaitTime,
    trackClickIBubbleBedsideManner,
    trackProfileScrollCount,
};
